import { createContext } from "react";

import useOutletController from "./useOutlet.controller";
const OutletContext = createContext<ReturnType<typeof useOutletController>>(undefined as any);
export default OutletContext;
